var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 8.66665H8.66659V12.6666H7.33325V8.66665H3.33325V7.33331H7.33325V3.33331H8.66659V7.33331H12.6666V8.66665Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconSmall);
export default __webpack_public_path__ + "static/media/plus-icon-small.a92b539f6d8bf5063be42c799d0c15cc.svg";
export { ForwardRef as ReactComponent };